<template>
    <app-page-content>
        <div class="d-print-none">
            <app-title text="Gestión de Contratista" />
        </div>
        <router-view></router-view>
    </app-page-content>
</template>
<script>
    export default {
        name: 'ContractorPage'
    };
</script>
